/**
 * The Acts Church wordmark (public/brand/acts-church-logo.png, black on transparent). It turns
 * white in dark mode through the `.proc-logo` class (CSS invert), so one file serves both schemes.
 */
export function ActsLogo({ height = 22, alt = 'Acts Church', className }: { height?: number; alt?: string; className?: string }) {
  return (
    <img
      src="/brand/acts-church-logo.png"
      alt={alt}
      height={height}
      width={Math.round(height * (600 / 298))}
      className={`proc-logo${className ? ` ${className}` : ''}`}
      style={{ height }}
      draggable={false}
      decoding="async"
    />
  );
}
